"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _Links = require("../utils/Links");

var _UrlBuilders = require("../utils/UrlBuilders");

var _defer = _interopRequireDefault(require("hs-promise-utils/defer"));

var OAUTHOR_NAMESPACE_CRM = 'crm.v2';
var handleMessageCallback;

var _getMessageCallbackHandler = function _getMessageCallbackHandler(deferred) {
  return function (message) {
    var origin = message.origin || message.originalEvent.origin || '';

    if (origin.indexOf('getsidekick') === -1 && origin.indexOf('hubspot') === -1) {
      return;
    }

    var data = message.data || {};
    var type = data.type || '';

    if (type.indexOf('INBOX_CONNECT') === -1) {
      return;
    }

    if (data.error === true) {
      deferred.reject(data);
    } else {
      deferred.resolve(data);
    }

    window.removeEventListener('message', handleMessageCallback);
    handleMessageCallback = null;
  };
};

var ConnectInbox = /*#__PURE__*/function () {
  function ConnectInbox(connectInboxUrl, serviceType, legalPrompt) {
    (0, _classCallCheck2.default)(this, ConnectInbox);
    this.connectInboxUrl = connectInboxUrl;
    this.serviceType = serviceType;
    this.legalPrompt = legalPrompt;

    if (this.connectInboxUrl === null) {
      console.error('"connectInboxUrl" is a required property on the "ConnectInbox" class.');
    }

    if (this.serviceType === null) {
      console.error('"serviceType" is a required property on the "ConnectInbox" class.');
    }
  }

  (0, _createClass2.default)(ConnectInbox, [{
    key: "connect",
    value: function connect(portalId) {
      var requestGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'CRM_INBOX_CONNECT';
      return this.connectWithOptions({
        requestGroup: requestGroup,
        portalId: portalId,
        checkPrivy: false
      });
    }
  }, {
    key: "baseConnect",
    value: function baseConnect() {
      var appNamespace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : OAUTHOR_NAMESPACE_CRM;
      var newWindow = arguments.length > 1 ? arguments[1] : undefined;
      var portalId = arguments.length > 2 ? arguments[2] : undefined;
      var isShared = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var urlOptions = arguments.length > 4 ? arguments[4] : undefined;
      newWindow.location.href = this.getConnectInboxUrl(null, appNamespace, portalId, isShared, urlOptions);
      return this.waitForConnectCallback();
    }
  }, {
    key: "waitForConnectCallback",
    value: function waitForConnectCallback() {
      var deferred = (0, _defer.default)();
      handleMessageCallback = _getMessageCallbackHandler(deferred);
      window.addEventListener('message', handleMessageCallback, false);
      return deferred.promise;
    }
  }, {
    key: "getConnectInboxUrl",
    value: function getConnectInboxUrl(next, appNamespace, portalId) {
      var isShared = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var _options$forceFreshCo = options.forceFreshConnect,
          forceFreshConnect = _options$forceFreshCo === void 0 ? false : _options$forceFreshCo,
          otherOptions = (0, _objectWithoutProperties2.default)(options, ["forceFreshConnect"]);
      var oAuthorParams = {};
      var inboxConnectParams = Object.assign({
        origin: window.location.origin,
        serviceType: this.serviceType,
        isShared: isShared
      }, otherOptions);

      if (portalId) {
        oAuthorParams.portalId = portalId;
        inboxConnectParams.portalId = portalId;
      }

      if (next) {
        inboxConnectParams.next = next;
      }

      if (forceFreshConnect) {
        oAuthorParams.forceFreshConnect = true;
      }

      var inboxConnectUrl = (0, _UrlBuilders.addQueryToUrl)((0, _Links.getInboxConnectPath)(portalId), inboxConnectParams);
      oAuthorParams.appendToFinal = inboxConnectUrl;
      return (0, _UrlBuilders.addQueryToUrl)(this.connectInboxUrl + "/" + (appNamespace || OAUTHOR_NAMESPACE_CRM), oAuthorParams);
    }
  }, {
    key: "connectWithOptions",
    value: function connectWithOptions(_ref) {
      var _this = this;

      var _ref$requestGroup = _ref.requestGroup,
          requestGroup = _ref$requestGroup === void 0 ? 'CRM_INBOX_CONNECT' : _ref$requestGroup,
          _ref$appNamespace = _ref.appNamespace,
          appNamespace = _ref$appNamespace === void 0 ? OAUTHOR_NAMESPACE_CRM : _ref$appNamespace,
          apiClient = _ref.apiClient,
          portalId = _ref.portalId,
          _ref$isShared = _ref.isShared,
          isShared = _ref$isShared === void 0 ? false : _ref$isShared,
          _ref$useActionRedirec = _ref.useActionRedirect,
          useActionRedirect = _ref$useActionRedirec === void 0 ? false : _ref$useActionRedirec,
          reconnectEmail = _ref.reconnectEmail,
          _ref$forceFreshConnec = _ref.forceFreshConnect,
          forceFreshConnect = _ref$forceFreshConnec === void 0 ? false : _ref$forceFreshConnec;
      return new Promise(function (resolve, reject) {
        _this.maybeShowPrivyPermissions(false, requestGroup, apiClient).then(function (newWindow) {
          _this.baseConnect(appNamespace, newWindow, portalId, isShared, {
            useActionRedirect: useActionRedirect,
            reconnectEmail: reconnectEmail,
            forceFreshConnect: forceFreshConnect
          }).then(resolve, function (err) {
            if (newWindow.close) {
              newWindow.close();
            }

            reject(err);
          });
        }, reject);
      });
    }
  }, {
    key: "maybeShowPrivyPermissions",
    value: function maybeShowPrivyPermissions(checkPrivy, requestGroup, apiClient) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var newWindow = null;
        var promptProps = {
          allowRequestGroup: requestGroup,
          apiClient: apiClient,
          onClick: function onClick() {
            resolve(newWindow = window.open());
          }
        };

        var windowReject = function windowReject(error) {
          if (newWindow && newWindow.close) {
            newWindow.close();
          }

          reject(error);
        };

        _this2.legalPrompt(promptProps).then(resolve, windowReject);
      });
    }
  }]);
  return ConnectInbox;
}();

var _default = ConnectInbox;
exports.default = _default;
module.exports = exports.default;